import { render, staticRenderFns } from "./EventMarketingGeneralForm.vue?vue&type=template&id=4efefbe2"
import script from "./EventMarketingGeneralForm.vue?vue&type=script&lang=js"
export * from "./EventMarketingGeneralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports